import { TopProject } from "../types/globalTypes";

export const sortProjectsByAvailableDate = (projects: TopProject[]): TopProject[] => {
    return projects.sort((a, b) => {
        const dateA = new Date(a.BecameAvailableDate || '');
        const dateB = new Date(b.BecameAvailableDate || '');
        return dateB.getTime() - dateA.getTime();
    });
}